// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate';
import zh_TW from 'vee-validate/dist/locale/zh_TW';
import router from '@/router/router';
import store from '@/store/store';
import '@/filter/filter';
import '@/event-bus/eventBus';
import App from './App.vue';
import VueAnalytics from 'vue-analytics'
import auth from '@/auth/auth'
import {headerScript} from '@/util/headerScript'

Vue.config.productionTip = false;
Vue.use(VeeValidate, {
    fieldsBagName: 'formFields',
});
Validator.localize('zh_TW', zh_TW);

/* eslint-disable no-new */
var vm_app = new Vue({
    el: '#app',
    store,
    router,
    auth,
    components: { App },
    template: '<App/>',
    computed: {
      loginOut: function() { // computed property will be updated when async call resolves
        return this.$store.state.profile.visit;
      }
    },
    watch: { // watch changes here
      loginOut: function(newValue, oldValue) {
        if(newValue){
          // header
          this.loadBlockHtml("headerMenu",  process.env.HEADERMENU);
          // siteMap
          this.loadBlockHtml("siteMapContainer", process.env.SITEMAPCONTAINER);
          // footer
          this.loadBlockHtml("footerbox", process.env.FOOTERBOX);

          if(this.$store.state.profile.name){
            // 判斷登入狀態去修改視圖
            $('#loginStatusMobile').addClass('memberActive');
            var tempHtml = $('#loginStatusMobile').html();

            const logoutUrl = `javascript:logout("${process.env.CAS_LOGOUT_URL}?service=${encodeURIComponent(process.env.MAIN_PAGE)}");`;

            $('#loginStatusMobile').html(tempHtml.replace('用戶/會員登入', '用戶/會員登出'))
            $('#loginStatusMobile a')[0].href = logoutUrl;

            $('#loginStatus').addClass('active');
            $('#loginStatus').prop('title', '登出')
            $('#loginStatus a')[0].href = logoutUrl;
          }

          var el_gt_year = document.getElementById("gt_year");
          if (el_gt_year) {
            el_gt_year.innerHTML = new Date().getFullYear();
          }
        }
      }
    },
    mounted(){},
    methods: {
      loadBlockHtml(id, url, data) {
        $.ajax({
          url: url,
          data: data,
          type: "POST",
          dataType: "text",
          async: false,
          success: function(html) {
            if(id === 'headerMenu'){
              html = '<header class="gt-header newHeader" data-spy="affix" data-offset-top="30">' + html + '</header>'
            }
            var htmlCode = $(html)
            $("#" + id).html(htmlCode);
          }
        });
      }
    },
    created() {},
});

Vue.use(VueAnalytics, {
    id: ["UA-4860632-1", "UA-4860632-2"],
    disableScriptLoader: true, // 必须在html中完成初始化，這裡顯示禁止去下載ga腳本
    router, // 確保路由切換時可以自動統計
    autoTracking: {
        pageviewOnLoad: false,
        pageviewTemplate (route) {
          return {
            page: router.path,
            title: document.title,
            location: window.location.href
          }
        }
    }
})



// WEBPACK FOOTER //
// ./src/main.js